import { ApiError } from './api.js';
import { ErrorCode } from '@novachat/shared';
/** Turkish text for an error, preferring Novadan's own wording where the server passes it on. */
export function errorMessage(error) {
    if (!(error instanceof ApiError))
        return 'Beklenmeyen bir hata oldu. Tekrar dene.';
    switch (error.code) {
        case ErrorCode.InvalidCredentials:
            return error.message || 'E-posta veya şifre hatalı.';
        case ErrorCode.InvalidTwoFactorCode:
            return error.message || 'Kod hatalı ya da süresi dolmuş.';
        case ErrorCode.NovadanUnavailable:
            return 'Novadan’a şu an ulaşılamıyor. Biraz sonra tekrar dene.';
        case ErrorCode.SoleOwner:
            return 'Bu kanalın tek sahibisin. Ayrılmadan önce birine Sahip rolünü ver ya da kanalı arşivle.';
        case ErrorCode.RateLimited:
            return 'Çok fazla deneme yaptın. Bir dakika bekleyip tekrar dene.';
        case ErrorCode.Forbidden:
            return 'Bunun için yetkin yok.';
        case ErrorCode.NotFound:
            return 'Bulunamadı. Silinmiş ya da erişimin kaldırılmış olabilir.';
        case ErrorCode.ValidationFailed:
            return 'Girdiğin bilgileri kontrol et.';
        case ErrorCode.PayloadTooLarge:
            return 'Dosya çok büyük. En fazla 95 MB gönderebilirsin.';
        case 'NETWORK_ERROR':
            return 'Bağlantı yok. İnternetini kontrol et.';
        default:
            return 'Sunucu hatası. Tekrar dene.';
    }
}
//# sourceMappingURL=errors.js.map